module.exports = new Promise((resolve,reject) => {
                  const remoteUrl = window.__CONFIG__.REACT_APP_INDUSTRY_REMOTE_URL;
                  const script = document.createElement('script');
                  script.src = remoteUrl;
                  script.onload = () => {
                  const proxy = {
                      get: (request) => window.industry.get(request),
                      init: (arg) => {
                      try {
                        return window.industry.init(arg);
                      } catch (e) {
                        console.warn('industry remote already initialized');
                      }
                    }
                  };
                  resolve(proxy);
                };
                script.onerror = (err) =>{
                  console.log('Failed to load remote script',err);
                  reject(new Error('Unable to load RemoteEntry file for industry MFE'));
                }
                document.head.appendChild(script);
          });